import RecordTemplate from "./RecordTemplate";

class RecordTemplates {
  constructor(private readonly _list: RecordTemplate[] = []) {
  }

  public isEmpty(): boolean {
    return this._list ? this._list.length <= 0 : true;
  }

  public toList(): RecordTemplate[] {
    return this._list;
  }
}

export default RecordTemplates;